import { Strong, InlineCode, Badge } from "./BlockPrimitives";

const renderInlineNode = (node, index) => {
  switch (node.type) {
    case "text":
      return <span key={index}>{node.value}</span>;
    case "strong":
      return <Strong key={index}>{node.value}</Strong>;
    case "inlineCode":
      return (
        <InlineCode key={index} variant={node.variant}>
          {node.value}
        </InlineCode>
      );
    case "br":
      return <br key={index} />;
    case "badge":
      return (
        <Badge key={index} color={node.color}>
          {node.value}
        </Badge>
      );
    case "em":
      return <em key={index}>{node.value}</em>;
    default:
      return null;
  }
};

const InlineContent = ({ content }) => {
  if (typeof content === "string") {
    return content;
  }

  if (!Array.isArray(content)) {
    return null;
  }

  return content.map(renderInlineNode);
};

export default InlineContent;
